module.exports = __webpack_public_path__ + "img/9788992844864.306ef8b6.jpg";